<router-outlet />
<p-toast>
  <!-- PrimeNG v21 Toast custom message template: @ContentChild('message') with
       context { $implicit: message } — replaces the default summary/detail block
       (the close button stays). Renders the summary, the detail when present
       (#1045: the support dialog surfaces the specific refusal reason as detail —
       without this it was dropped and only the generic summary showed), plus, for
       messages carrying data.viewDeletedLink (customer soft-delete), an in-app link. -->
  <ng-template #message let-message>
    <div class="toast-message-content">
      <span class="toast-summary">{{ message.summary }}</span>
      @if (message.detail) {
        <span class="toast-detail">{{ message.detail }}</span>
      }
      @if (message.data?.viewDeletedLink) {
        <a class="toast-view-deleted" [routerLink]="message.data.viewDeletedLink">
          {{ 'View deleted' | t }}
        </a>
      }
    </div>
  </ng-template>
</p-toast>
